// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_PeriodCalculationSummaryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/period_calculation_summary endpoint
 *
 * Returns all executions and totals for the period grouped by user.
 * The summary is an aggregate object built from multiple model joins
 * (period header + grouped executions + totals); treated as opaque to
 * preserve existing wire shape.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_PeriodCalculationSummaryResponseDados {
summary: object
}

export type Payroll_PeriodCalculationSummaryResponse = ApiResponse<Payroll_PeriodCalculationSummaryResponseDados>;

registerResponseContract('Payroll_PeriodCalculationSummaryResponse', {
  summary: { type: 'object',  required: true },
})
